
import { BlogSection } from '@/types/blog';

export const ethikSection: BlogSection = {
  id: 'ethik',
  title: 'Ethik und Standards im Coaching',
  content: `
    <p>
      Auch wenn ich mich selbst für den Weg der persönlichen Freiheit entschieden habe und keinem 
      Coaching-Verband angehöre, habe ich mich zu einer <strong>Selbstverpflichtung auf die ethischen Standards 
      der ICF</strong> entschieden. Darauf dürfen Sie als Klient vertrauen.
    </p>
    
    <p>
      Die ICF-Standards zeigen, dass Coaching nicht nur ein Geben, sondern auch ein 
      <strong>lebenslanges Lernen</strong> bedeutet. Als Teil der weltweiten Coaching-Bewegung empfinde ich 
      Dankbarkeit und Erfüllung – Gefühle, die aus der sinnvollen Begleitung von Menschen entstehen.
    </p>
  `
};
